import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { orderDetailsAPI } from 'src/app/services/apiRoutes';
import { OrderSearch } from "../model/orderSearch";

@Injectable()
export class OrderSearchService {
    constructor(public http: HttpClient) { }

    quickSearch(data: string): Promise<OrderSearch> {
        return this.http.get<OrderSearch>(orderDetailsAPI + '/quick-search?query=' + data).toPromise();
    }

}
